export enum SnackbarType {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
}

export const SNACKBAR_DURATION = {
    SHORT: 3000,
    LONG: 5000,
    VERY_LONG: 8000,
} as const

export type SnackbarDuration =
    | typeof SNACKBAR_DURATION.SHORT
    | typeof SNACKBAR_DURATION.LONG
    | typeof SNACKBAR_DURATION.VERY_LONG
